import { TOURIST_LOGIN, USER_INFO } from "../apis/user";

export default {
  data() {
    return {};
  },
  methods: {
    loginTourist(code) {
      this.$post(
        `${TOURIST_LOGIN}?code=${code}`,
        {},
        resp => {
          if (resp.token) {
            this.$store.commit("token", resp.token);
            this.$store.commit("userType", "tourist_login");
            this.loadUser();
          } else {
            // this.$router.push("/selectPakage?cabinetshow=true")
            this.allowedMaps = true;
            this.$router.push("/home?cabinetshow=true");
          }
        },
        error => {
          console.log(error);
        }
      );
    },
    loadUser() {
      this.$loading(true);
      this.$get(
        USER_INFO,
        {},
        res => {
          this.$loading(false);
          if (res.user) {
            this.$store.commit("user", res.user);
            this.$router.push("/selectPakage?cabinetshow=true");
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user
            })
              .then(() => {
                this.loadUser();
              })
              .catch(() => {
                this.$store.commit("token", null);
              });
          }
        },
        err => {
          this.$loading(false);
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: err,
            showCancel: false
          }).then(() => {
            this.$store.commit("token", null);
          });
        }
      );
    }
  }
};
